interface RobotAndGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const RobotAndGearSVG = ({ color, style }: RobotAndGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="50"
    viewBox="0 0 38 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_7682)">
      <path
        d="M23.5858 8.35452H13.4215C12.0113 8.35452 10.8682 9.49768 10.8682 10.9078V16.2297C10.8682 17.6399 12.0113 18.783 13.4215 18.783H23.5858C24.996 18.783 26.1391 17.6399 26.1391 16.2297V10.9078C26.1391 9.49768 24.996 8.35452 23.5858 8.35452Z"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.5088 18.783V22.0896"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.323 34.2888V24.0951C27.323 23.0581 26.4817 22.2168 25.4447 22.2168H11.5726C10.5357 22.2168 9.69434 23.0581 9.69434 24.0951V34.2399C9.69434 35.1888 10.4672 35.9616 11.4161 35.9616L25.6012 36.0105C26.5599 36.0105 27.3328 35.2377 27.3328 34.2888H27.323Z"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.1708 13.5688C16.1708 13.8721 15.9263 14.1068 15.6328 14.1068C15.3393 14.1068 15.0947 13.8623 15.0947 13.5688C15.0947 13.2753 15.3393 13.0307 15.6328 13.0307C15.9263 13.0307 16.1708 13.2753 16.1708 13.5688Z"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.9326 13.5688C21.9326 13.8721 21.688 14.1068 21.3945 14.1068C21.101 14.1068 20.8564 13.8623 20.8564 13.5688C20.8564 13.2753 21.101 13.0307 21.3945 13.0307C21.688 13.0307 21.9326 13.2753 21.9326 13.5688Z"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.5088 8.35453V4.59793"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.5335 2.57287C20.5335 3.68811 19.6237 4.59791 18.5084 4.59791C17.3932 4.59791 16.4834 3.68811 16.4834 2.57287C16.4834 1.45762 17.3932 0.547821 18.5084 0.547821C19.6237 0.547821 20.5335 1.45762 20.5335 2.57287Z"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.41086 18.6363C7.95322 19.1156 6.37819 19.1939 4.86185 18.8222L3.82487 18.5678L0.674805 24.0168L1.40852 24.7799C2.92485 26.3549 3.71726 28.468 3.70748 30.6496V30.7278C3.70748 32.8996 2.91507 35.0029 1.40852 36.5682L0.674805 37.3312L3.82487 42.7803L4.86185 42.5259C6.97494 42.0074 9.18586 42.3596 11.0739 43.4553C11.0935 43.4651 11.1131 43.4846 11.1424 43.4944C13.0403 44.5803 14.4686 46.3217 15.0751 48.425L15.3686 49.4424H21.6687L21.9622 48.4152C22.5688 46.3217 23.997 44.5803 25.8851 43.4944C25.8851 43.4944 25.9047 43.4846 25.9145 43.4749C25.9145 43.4749 25.934 43.4651 25.9438 43.4553C27.8319 42.3596 30.0526 41.9879 32.1657 42.5161L33.2027 42.7705L36.3528 37.3215L35.619 36.5584C34.1027 34.9834 33.3103 32.8703 33.3201 30.6887C33.3201 30.6594 33.3201 30.6398 33.3201 30.6105C33.3201 28.4387 34.1125 26.3354 35.619 24.7701L36.3528 24.007L33.2027 18.558L32.1657 18.8124C30.6494 19.1841 29.0743 19.1059 27.6167 18.6265"
        stroke={color}
        strokeWidth="1.09568"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_7682">
        <rect width="37.0182" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default RobotAndGearSVG;
